import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { LANGUAGES_SHORT, RESONANCE_STRUCTURE, RESONANCE_THEMES, RESONANCE_VISIONS } from '../../../constants';
import callApi from '../../../service/callApi';
import sendRequest from '../../../service/sendRequest';
import { somethingWrongNotification } from '../../../redux/notifier/notifierActions';
import CommonButton, { BUTTON_STYLES } from '../../../components/common-button/CommonButton';

function ResonanceIvisButton() {
  const dispatch = useDispatch();
  const { t } = useTranslation('resonance');
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const serverUrl = useSelector((state) => state.securityNew.serverUrl);
  const isProjectLoading = useSelector((state) => state.resonance.isProjectLoading);
  const { theme, vision, dataStructure, lang } = useSelector((state) => state.resonance.projectInfo);

  const redirectToResonance = async () => {
    setIsLoading(true);
    const response = await sendRequest(() => callApi.get(`/api/ivis/token/generate`), {
      onError: () => setIsLoading(false),
    });

    if (response.status === 200) {
      const query = [
        `sourceId=${id}`,
        `token=${response.data.token}`,
        `theme=${(theme || RESONANCE_THEMES.FACTIVE).toLowerCase()}`,
        `vision=${(vision || RESONANCE_VISIONS.DEFAULT).toLowerCase()}`,
        `dataStructure=${(dataStructure || RESONANCE_STRUCTURE.RESPONDENTS).toLowerCase()}`,
        `lang=${(lang || LANGUAGES_SHORT.ENGLISH).toLowerCase()}`,
      ];

      setIsLoading(false);
      window.open(`${serverUrl}/chart/resonance/?${query.join('&')}`, '_blank').focus();
    } else {
      dispatch(somethingWrongNotification());
    }
  };

  return (
    <CommonButton
      styleColor={BUTTON_STYLES.PRIMARY}
      maxWidth={150}
      onClick={redirectToResonance}
      isLoading={isLoading}
      disabled={isProjectLoading}>
      {t('redirectToIvis')}
    </CommonButton>
  );
}

export default ResonanceIvisButton;
